<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FRHhpW/tc-custom/9780310354390.jpg?1728259422438" alt="This image is the cover for the book Run the Mile You're In"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Run the Mile You're In
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Journey with Olympian and American half marathon record holder Ryan Hall as he reflects on the joys and trials of running and, along the way, shows you how he found God in every step.</b></p><p>Ryan Hall is an Olympic athlete and American record holder in the half marathon, but as a kid, Ryan hated running. He wanted nothing to do with the sport until one day, he felt compelled to run the fifteen miles around his neighborhood lake. He was hooked.</p><p>From that day forward, Ryan felt a God-given purpose in running. He knew he could, and would, race with the best runners in the world and that his talent was a gift to serve others. These two truths launched Ryan's twenty-year athletic career and guided him through epic failures and exceptional breakthroughs to competing at the highest level.</p><p>Now a coach, speaker, and nonprofit partner, Ryan shares the powerful faith behind his athletic achievements and the lessons he learned that helped him push past his limits, make space for relationships that enrich his life on and off the running trails, and cultivate a positive mindset.</p><p>As you learn more about Ryan and his incredible path, you'll gain the tools you need to:</p>Focus on your purpose and say no to distractionsSelect and strive for the right goals--goals for the heart <i>and</i> the bodyDeal with defeat and disappointmentEndure immense pain and build resilienceRun like you've already won<p>Ryan's story is one of encouragement and inspiration for readers of any age and level of running ability--or none at all. It's a story that shows that you, too, can change your outlook, see God's hand in your life, and run the race that really matters.</p><p><b>Praise for <i>Run the Mile You’re In</i>:</b></p><p>"<i>Run the Mile You're In</i> is not about winning races and setting running records. It's about always moving forward. Moving outward is an act of courage. The reward is living the lifestyle and embracing the dream."</p><p><b>--Bart Yasso, newly retired chief running officer, <i>Runner's World</i></b></p><p>"Ryan's journey on and off the course is touching and a meaningful way to live by helping others. This is an uplifting book of joy and finding your sense of purpose."</p><p><b>--Meb Keflezighi, Olympic silver medalist; Boston Marathon and NYC Marathon champion</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ryan Hall
      </h2>
      
      <p class="authorDescription body article"><P>Ryan Hall is the American Record holder for the half marathon (59:43) and has the fastest marathon time ever run by an American, with a PR of 2:04:58. He represented the United States of America at the 2008 and 2012 Olympic Games in the marathon. Ryan grew up in Big Bear Lake in southern California, attended Stanford University, and is currently retired from professional running. Ryan is a coach and speaker and lives in Flagstaff, AZ with his wife Sara and their four adopted daughters from Ethiopia.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsChristianPublishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1a1c9ee1